import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { UserPrefsProvider } from './Components/context/UserPrefs';
import { ErrorBoundary } from './Components/ErrorBoundary';

if (typeof window !== 'undefined') {
  const p = window.location.pathname || '';
  if (p.startsWith('/senerfiN')) {
    const rest = p.slice('/senerfiN'.length);
    const next = '/senerfi' + rest + (window.location.search || '') + (window.location.hash || '');
    window.location.replace(next);
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <UserPrefsProvider>
        <App />
      </UserPrefsProvider>
    </ErrorBoundary>
  </React.StrictMode>
);


reportWebVitals();
